export function useItem() {
    function getThemeClass(item) {
        return item && item.Theme && item.Theme.SelectedValue ? `theme${item.Theme.SelectedValue}` : null;
    }

    function mapItems(data) {
        const mappedData = data.map(x => {
            const fields = x.Item.Fields.map(() => mapItem(x.Item));

            fields.push({'systemName': x.Item.SystemName});
            fields.push({'id': x.ID});
            fields.push({'pageId': x.PageID});

            return Object.assign({}, ...fields);
        });

        return mappedData;
    }

    function mapItem(item) {
        return mapItemFields(item.Fields);
    }

    function mapItemFields(itemFields, wrapperField = undefined) {
        let returnValue = [];
        const fieldObjects = [];

        itemFields.forEach(field => {
            if (wrapperField) {
                const fieldObj = mapItemField(field);
                fieldObjects.push(fieldObj);
            } else {
                returnValue.push(mapItemField(field));
            }
        });

        if (wrapperField) {
            returnValue = Object.assign({}, ...fieldObjects);
            return returnValue;
        } else {
            return Object.assign({}, ...returnValue);
        }
    }

    function mapItemField(field) {
        const fieldType = getItemFieldType(field);

        switch (fieldType) {
            case 'string':
                return mapStringField(field);
            case 'boolean':
                return mapBooleanField(field);
            case 'array':
                return mapArrayField(field);
            case 'object':
                return mapObjectField(field);
            case 'item':
                return mapItemItemField(field);
            case null:
                console.warn('Field has no recognized type', field);
                break;
        }
    }

    function mapStringField(field) {
        const returnObj = {};
        returnObj[field.SystemName] = field.Value;

        return returnObj;
    }

    function mapBooleanField(field) {
        const returnObj = {};
        returnObj[field.SystemName] = field.Value;

        return returnObj;
    }

    function mapArrayField(field) {
        const returnObj = {};
        let returnValue;

        if (field.Value.length > 1) {
            returnValue = [];

            field.Value.forEach(value => {
                returnValue.push(mapItemField(value));
            });
        } else {
            returnValue = mapItemField(field.Value[0]);
        }

        returnObj[field.SystemName] = returnValue;

        return returnObj;
    }

    function mapObjectField(field) {
        if (field.Value !== undefined && typeof field.Value == 'object') {
            let returnObj = {};

            if (field.SystemName) {
                returnObj[field.SystemName] = mapItemField(field.Value, field.SystemName);
            } else {
                returnObj = mapItemField(field.Value);
            }

            return returnObj;
        } else {
            let returnObj = {};

            if (field.SystemName) {
                returnObj[field.SystemName] = field;
            } else {
                returnObj = field;
            }

            return returnObj;
        }
    }

    function mapItemItemField(field) {
        let returnObj = {};

        if (field.Value && field.Value.Fields) {
            if (field.SystemName !== undefined) {
                returnObj[field.SystemName] = mapItemFields(field.Value.Fields);
            } else {
                returnObj = mapItemFields(field.Value.Fields);
            }
        } else if (field.Fields) {
            returnObj = mapItemFields(field.Fields);
        }

        return returnObj;
    }

    function getItemFieldType(field) {
        if (field !== undefined) {
            if (field.Value !== undefined) {
                if (typeof field.Value === 'string') {
                    return 'string';
                }
                else if (typeof field.Value === 'boolean') {
                    return 'boolean';
                } else if (typeof field.Value === 'object') {
                    if (field.Value.length !== undefined) { // Array.isArray()
                        return 'array';
                    } else if (field.Value.Fields) {
                        return 'item';
                    } else {
                        return 'object';
                    }
                } else {
                    return null;
                }
            } else {
                if (typeof field === 'object') {
                    if (field.Length != undefined) {
                        return 'array';
                    } else if (field.Fields) {
                        return 'item';
                    } else {
                        return 'object';
                    }
                } else {
                    return null;
                }
            }
        }
    }

    return {
        getThemeClass,
        mapItems,
    };
}
